import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "product-selection" }
const _hoisted_2 = { class: "product-selection-list row py-2" }
const _hoisted_3 = {
  key: 0,
  class: "col-12"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", null, "Selecting these options will change other options you've selected.", -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "product-selection-list-item col-lg-4 col-6" }

import { computed } from 'vue'
import ProductCard from './ProductCard.vue'


export default /*#__PURE__*/_defineComponent({
  props: ['products', 'fieldId'],
  emits: ['update-route', 'update-selection'],
  setup(__props, { emit: emits }) {

const props = __props



let firstCompatibleIndex = computed(() => {
	return props.products.findIndex(product => product?.compatibilityMessage)
})

let isFirstWithCompatMessage = (index) => {
	return index === firstCompatibleIndex.value
}



const handleUpdateSelection = async(selection: any) => {
	await emits('update-selection', { ...selection });
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.products, (product, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: product.id
        }, [
          (_unref(isFirstWithCompatMessage)(index))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(ProductCard, _mergeProps(product, {
              fieldId: __props.fieldId,
              onUpdateSelection: handleUpdateSelection
            }), null, 16 /* FULL_PROPS */, ["fieldId"])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}
}

})